export const ApiDef_FHIRResourceParamValue = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map